<template>
  <div style="display: contents">
    <b-row>
      <b-col md="12" class="mb-3">
        <div class="package-name-background p-2">
          <p>{{ pack.name }}</p>
        </div>
      </b-col>
      <b-col md="12" v-if="pack.description">
        <p style="white-space: pre-line;">{{ pack.description }}</p>
      </b-col>
      <b-col md="6">
        <h6 class="package-title">Servicii incluse</h6>
        <hr>
        <p style="white-space: pre-line;">{{ pack.included }}</p>
      </b-col>
      <b-col md="6">
        <h6 class="package-title">Servicii neincluse</h6>
        <hr>
        <p style="white-space: pre-line;">{{ pack.notIncluded }}</p>
      </b-col>
    </b-row>
    <FlightInfo :info="pack.flightInfo" v-if="pack.flightInfo" />
    <b-row v-if="showPrices">
      <b-col md="12">
        <div class="table-responsive">
          <h6 class="package-title">Detalii tarif</h6>
          <table class="table table-sm border table-hover">
            <thead class="t-head hh-t-head">
              <tr>
                <td>Tip camera</td>
                <td></td>
                <td>Tip masa</td>
                <td>Pret catalog</td>
                <td>Pret redus</td>
                <td>Disponibilitate</td>
              </tr>
            </thead>
            <tbody>
              <template v-for="category in pack.categories">
                <category :category="category" :currency="currency" :showCollapse="false" :showBook="false"
                  :transport="transport" :key="'categoryInfo' + category.id" />
              </template>
            </tbody>
          </table>
        </div>
        <Legend />
      </b-col>
    </b-row>
    <b-row v-if="showExtras">
      <Extras :extras="pack.categories[0].extras" :currency="currency" />
    </b-row>
    <b-row>
      <b-col md="12">
        <p class="my-3 border-top border-bottom strong text-danger">
          MENTIONAM CA UNELE UNITATI DE CAZARE POT AVEA CONDITII DE PLATA/ANULARE/PENALIZARE DIFERITE FATA DE CELE
          STANDARD.
          PENTRU REZERVARILE NON REFUNDABLE, PLATA SE FACE INTEGRAL IN MOMENTUL REZERVARII, IAR PENALIZAREA IN CAZUL
          ANULARII ESTE DE 100%.
        </p>
      </b-col>
    </b-row>
    <b-row v-if="showNotes">
      <b-col md="12">
        <!-- {{result}} -->
        <ul class="list-inline">
          <li class="list-group-item"><b>NOTA:</b> <span> preturile si suplimentele afisate sunt calculate per total
              rezervare!</span> </li>
          <li class="list-group-item"><b>NOTA:</b> <span> elementele suplimentare/optionale care au valoarea afisata nu
              sunt
              incluse in pretul rezervarii!</span></li>
        </ul>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import category from '@/app/private/shared/components/category_result'
import Legend from '@/app/private/shared/components/legend'
import FlightInfo from './flight_info'
import Extras from './extras'

export default {
  name: 'PackageInfo',
  props: {
    pack: {
      type: Object,
      required: true
    },
    currency: {
      type: String
    },
    showPrices: {
      type: Boolean,
      default: true
    },
    showExtras: {
      type: Boolean,
      default: true
    },
    showNotes: {
      type: Boolean,
      default: true
    },
    transport: {
      type: String
    }
  },
  components: { category, FlightInfo, Extras, Legend }
}
</script>
